
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.146 2.986a.66.66 0 00-.66.66v11.875c0 .364.296.66.66.66h7.917a.66.66 0 00.66-.66V7.604h-2.64a1.979 1.979 0 01-1.979-1.979V2.986H6.146zm5.278.933l2.365 2.366h-1.706a.66.66 0 01-.66-.66V3.92zm-7.257-.273c0-1.093.886-1.979 1.979-1.979h4.618c.175 0 .343.07.466.193l4.618 4.618a.658.658 0 01.194.467v8.576a1.98 1.98 0 01-1.98 1.98H6.146a1.979 1.979 0 01-1.98-1.98V3.646zm3.298 7.257a.66.66 0 01.66-.66h1.98a.66.66 0 010 1.32h-1.98a.66.66 0 01-.66-.66zm0 2.639a.66.66 0 01.66-.66h3.958a.66.66 0 010 1.32H8.125a.66.66 0 01-.66-.66z"}})])
          )
        }
      }
    